module.exports = __webpack_public_path__ + "img/alice-laxa.824baeec.png";